'use strict';

import { LoggerService, MessageService, PhoneNumberService } from '@wephone-utils';
import { Injectable, isDevMode } from '@angular/core';
import CallingExtensions from '@hubspot/calling-extensions-sdk';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { PhoneService } from './phone.service';

@Injectable()
export class HubspotService {

  callingExt: CallingExtensions;

  private defaultSize = {
    width: 400,
    height: 600
  };

  constructor(
    private readonly messageService: MessageService,
    private readonly authService: AuthenticationService,
    private readonly phoneService: PhoneService,
    private readonly phoneNumberService: PhoneNumberService,
    private readonly loggerService: LoggerService,
  ) {

    this.callingExt = new CallingExtensions({
      debugMode: isDevMode(),
      eventHandlers: {
        onDialNumber: (data: any) => {
          this.onDialNumber(data);
        }
      }
    });

    this.messageService.subscribe('jsphone:call_start', (sipCallId: string) => {
      const jsphone = this.phoneService.getPhoneDriver();
      if (!jsphone) {
        this.loggerService.error('No jsphone driver');
        return;
      }

      const call = jsphone.getCallBySipCallId(sipCallId);
      if (!call) {
        this.loggerService.error('Cannot get call from sip call id', sipCallId);
        return;
      }

      if (call.isInbound()) {
        // this.loggerService.log('Call is inbound');
        return;
      }

      const callInfo = {
        phoneNumber: call.remoteNumber,
        createEngagement: false
      };

      // this.loggerService.log('Hubspot outgoing callInfo', callInfo);
      // this.loggerService.log('Hubspot outgoing call', call);
      this.callingExt.outgoingCall(callInfo);
    });

    this.messageService.subscribe('jsphone:call_end', (sipCallId: string) => {
      // this.loggerService.log(`Call with Id ${sipCallId} ended`);
      this.callingExt.callEnded();
    });

    this.messageService.subscribe('application:login:success', () => {
      this.callingExt.userLoggedIn();
    });

    this.messageService.subscribe('auth:logged_out', () => {
      this.callingExt.userLoggedOut();
    });

    // this.messageService.subscribe('phone:call_end', () => {
    //   this.callingExt.callEnded();
    // });
  }

  initialized(): void {
    this.callingExt.initialized({
      isLoggedIn: this.authService.isAuthenticated(),
      sizeInfo: this.defaultSize,
    });
  }

  onDialNumber(data: any): void {
    const { phoneNumber } = data;
    setTimeout(() => {
      this.phoneService.makeCall(this.phoneNumberService.normalizeNumber(phoneNumber));
    }, 1000);
  }
}
